import { saveStateToLocalStorage, loadStateFromLocalStorage } from './browserLocalStorage';
import { saveStateToSandboxedFileSystem, loadStateFromSandboxedFileSystem } from './sandboxedFsStorage';

const userChoiceJsonKey = 'fileSystemPersistenceUserChoiceJson';

const fourWeeksInMs = 4 * 7 * 24 * 60 * 60 * 1000;

export const userHasRejectedFileBasedPersistenceInvitationRecently = () => {
  const serializedJson = localStorage.getItem(userChoiceJsonKey);
  if (!serializedJson) {
    return false;
  }
  const storedObj = JSON.parse(serializedJson);
  const { accepted, date } = storedObj;
  if (accepted) {
    return false;
  }
  const jsDate = Date.parse(date);
  const horizon = new Date();
  horizon.setTime(horizon.getTime() - fourWeeksInMs);
  return jsDate > horizon;
};

const onChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
const userHasRejectedInvitationRecently = userHasRejectedFileBasedPersistenceInvitationRecently();
let useFileStorage = onChrome && !userHasRejectedInvitationRecently;
let useLocalStore = !useFileStorage;

export const saveState = (state) => {
  if (useLocalStore) {
    saveStateToLocalStorage(state);
  } else if (useFileStorage) {
    saveStateToSandboxedFileSystem(state);
  }
};

export const loadState = (continuationFunction) => {
  if (useLocalStore) {
    const loadedState = loadStateFromLocalStorage();
    continuationFunction(loadedState);
  } else if (useFileStorage) {
    loadStateFromSandboxedFileSystem(continuationFunction, switchToLocalStorageFunction);
  }
};

export const clearLocalStorage = () => {
  saveState({});
};

const switchToLocalStorageFunction = () => {
  recordUserRejectionOfFileStorage();
  useFileStorage = false;
  useLocalStore = true;
};

const recordUserRejectionOfFileStorage = () => {
  const now = new Date();
  const dateStr = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
  const objToStore = {
    accepted: false,
    date: dateStr,
  };
  const serializedObj = JSON.stringify(objToStore);
  localStorage.setItem(userChoiceJsonKey, serializedObj);
};

export const recordUserAcceptanceOfFileStorage = () => {
  const now = new Date();
  const dateStr = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
  const objToStore = {
    accepted: true,
    date: dateStr,
  };
  const serializedObj = JSON.stringify(objToStore);
  localStorage.setItem(userChoiceJsonKey, serializedObj);
};
